export const Title = ({ title }: { title: string }) => (
  <h1>
    {title}
    <div className="vixell-gradient w-[560px] h-[1px]"></div>
  </h1>
)
